import React from "react";
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import styles from "./customInputText.module.css";

type CustomInputTextType = {
    id: string;
    label?: string;
    textValue: any;
    setTextValue: (value: any) => void;
    required?: boolean;
    type?: string;
    error?: boolean;
    disabled?: boolean;
    helperText?: string;
    onChange?: () => void;
    startIcon?: any;
    placeholder?: string;
    className?: any;
}

const CustomInputText = (props: CustomInputTextType) => {

    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <div className={styles.container_input}>
            {props.label && <label className={styles.label}>{props.label}</label>}
            <span className={styles.span_input}>
                { props.startIcon && <div>{props.startIcon}</div>}
                <input
                    name={props.id}
                    type={showPassword ? 'text' : props.type}
                    className={`${props.className} ${styles.input}`}
                    id={props.id}
                    value={props.textValue}
                    onChange={e => {
                        props.setTextValue(e.target.value);

                        if (props.onChange)
                            props.onChange();
                    }}
                    required={props.required}
                    disabled={props.disabled}
                    placeholder={props.placeholder}
                />
                { props.type === 'password' &&
                    <span className={styles.password_icon}>
                        <IconButton
                            aria-label={
                                showPassword ? 'hide the password' : 'display the password'
                            }
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                            >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </span>
                }
            </span>
            <span className={`${styles.helperText} ${props.error && styles.errorText}`}>{props.helperText}</span>
        </div>
    );
}

export default CustomInputText;